import { render, staticRenderFns } from "./OverviewModal.vue?vue&type=template&id=27c6dfe2&scoped=true&"
import script from "./OverviewModal.vue?vue&type=script&lang=js&"
export * from "./OverviewModal.vue?vue&type=script&lang=js&"
import style0 from "./OverviewModal.vue?vue&type=style&index=0&id=27c6dfe2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c6dfe2",
  null
  
)

export default component.exports